var warn = function warn(msg) {
  // eslint-disable-next-line no-console
  console.warn("[@xo-union/tk-component-picture]: ".concat(msg));
};
export default warn;